<template>
  <div class="paginator" v-if="totalPages > 1">
    <div
      v-for="(item, idx) in template"
      :key="idx"
      :class="[{ active: page === item.value }, item.type]"
      class="item"
      @click="handleChangePage(item)"
    >{{ item.value }}</div>
  </div>
</template>

<script>
const ITEMS_LIMIT = 6;
const THRESHHOLD = 4;

export default {
  name: 'pagination-element',

  props: {
    model: {
      total: Number,
      limit: Number,
      skip: Number,
    },
  },

  methods: {
    handleChangePage(item) {
      if (typeof item.value === 'number' && item.value !== this.page) {
        const skip = (item.value - 1) * this.model.limit;
        this.$emit('change', skip);
      }
    },

    getFullTemplate() {
      return Array.from(
        {
          length: this.totalPages,
        },
        (_, idx) => ({
          type: 'number',
          value: idx + 1,
        })
      );
    },

    getLeftTemplate() {
      const template = Array.from(
        {
          length: 4,
        },
        (_, idx) => ({
          type: 'number',
          value: idx + 1,
        })
      );

      return template.concat([
        {
          type: 'ellipsis',
          value: '...',
        },
        {
          type: 'number',
          value: this.totalPages,
        },
      ]);
    },

    getRightTemplate() {
      const template = [
        {
          type: 'number',
          value: 1,
        },
        {
          type: 'ellipsis',
          value: '...',
        },
      ];

      return template.concat(
        Array.from(
          {
            length: 4,
          },
          (_, idx) => ({
            type: 'number',
            value: this.totalPages - THRESHHOLD + idx + 1,
          })
        )
      );
    },
    getNestedTemplate() {
      const isNearestToStart =
        this.totalPages - this.model.page >= this.totalPages / 2;

      const nestedTemplate = [
        {
          type: 'number',
          value: isNearestToStart ? this.page : this.page - 1,
        },
        {
          type: 'number',
          value: isNearestToStart ? this.page + 1 : this.page,
        },
      ];

      return [
        {
          type: 'number',
          value: 1,
        },
        {
          type: 'ellipsis',
          value: '...',
        },
        ...nestedTemplate,
        {
          type: 'ellipsis',
          value: '...',
        },
        {
          type: 'number',
          value: this.totalPages,
        },
      ];
    },
  },

  computed: {
    totalPages() {
      return Math.ceil(this.model.total / this.model.limit);
    },

    page() {
      return Math.ceil(this.model.skip / this.model.limit) + 1;
    },

    template() {
      if (this.totalPages <= ITEMS_LIMIT) {
        return this.getFullTemplate();
      }

      if (this.page <= THRESHHOLD) {
        return this.getLeftTemplate();
      }

      if (this.page >= this.totalPages - THRESHHOLD) {
        return this.getRightTemplate();
      }

      return this.getNestedTemplate();
    },
  },
};
</script>

<style lang="scss" scoped>
.paginator {
  display: flex;
  align-items: center;
  justify-content: center;

  .item {
    width: 30px;
    height: 30px;
    padding: 0 5px;
    border-radius: 50%;
    color: var(--main-text-color);
    font-size: 14px;
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;

    &:not(:last-child) {
      margin-right: 8px;
    }

    &.number:hover:not(.active) {
      cursor: pointer;
    }

    &.active {
      border: 1px solid var(--aluminnium-color);
    }
  }
}
</style>